import getFormatMessage from '../../../locales/get-format-message';
import { MessageSubType } from '../../../model/api-modules';

export const SYSTEM_LIST = [
  {
    label: getFormatMessage('system_list_online'),
    value: MessageSubType.FunctionRelease,
  },
  {
    label: getFormatMessage('system_list_adjust'),
    value: MessageSubType.FunctionRevise,
  },
  {
    label: getFormatMessage('system_list_bug_fix'),
    value: MessageSubType.Hotfix,
  },
  {
    label: getFormatMessage('system_list_upgrade'),
    value: MessageSubType.SystemUpgrade,
  },
];
